// Vue Tooltip Plugin
// https://github.com/Akryum/v-tooltip
import breakpoints from '@/vue-tailwind-breakpoints';
import Vue from 'vue';

import VTooltip from 'v-tooltip';
const options = {defaultTrigger: breakpoints.w >= breakpoints.screens.lg ? 'hover focus' : 'click'};

Vue.use(VTooltip, options);
